import DataFolder from './DataFolder';
import DataFile from './DataFile';

export default class SecureArea {
    constructor() {
        this.$parent = $('#secure-explorer');
        this.$spinner = $('.mxm_securearea_next .progress');
        this.deeplinkData = $('.mxm_securearea_next').data('deeplink');
        this.deeplinkDepth = 0;
        global.dataUrl = $('.mxm_securearea_next').data('baseurl');
        global.maxFileSize = $('.mxm_securearea_next').data('maxfilesize');
        global.allowedFileExtensions = $('.mxm_securearea_next').data('allowedfileextensions');
        global.dataActionPrefix = "mxm_securearea_";

        var baseFolder = parseInt($('.mxm_securearea_next').data('basefolder'));
        if (baseFolder > 0) {
            this.getFolderData(baseFolder, this.$parent);
        }
        else {
            this.getFolderData("", this.$parent);
        }

        if ($('.mxm_securearea_next').data('deeplinkpermissionerror')) {
            $.confirm({
                type: 'red',
                typeAnimated: true,
                icon: 'fa fa-warning',
                title: 'Fehler!',
                content: '<p>Sie verfügen nicht über ausreichende Berechtigung um den gewünschten Link zu öffnen.</p>',
                buttons: {
                    btnClose: {
                        text: 'Schliessen',
                        keys: ['esc']
                    }
                }
            });
        }

        if ($('.mxm_securearea_next').data('deeplink')) {
            $(window).one('entriesloaded', () => {
                if (this.deeplinkData && this.deeplinkData[this.deeplinkDepth]) {
                    const link = this.deeplinkData[this.deeplinkDepth];
                    this.deeplinkDepth++;
                    if (link.folder) {
                        const folderLink = document.querySelector(`[data-id="${link.id}"]`);

                        if (folderLink) {
                            folderLink.click();
                            if (this.deeplinkData.length == 1) {
                                folderLink.classList.add("focus");
                                setTimeout(function() {
                                    // Code, der erst nach 2 Sekunden ausgeführt wird
                                    folderLink.scrollIntoView({behavior: "smooth"});
                                }, 500);
                            }
                        }
                    }
                }
            });
        }
    }
    loadEntries($parent, data) {
        if (this.deeplinkData) {
            if (this.deeplinkData.length - 1 > this.deeplinkDepth) {
                this.$parent[0].style.opacity = 0;
                this.$parent[0].style.height = 0;
                this.addSpinner();
            } else {
                this.$parent[0].style.transition = "opacity .2s ease";
                this.$parent[0].style.opacity = 1;
                this.$parent[0].style.height = "auto";
                this.removeSpinner();
            }
        }

        if (data.folders.length == 0 && data.files.length == 0) {
            $parent.append('<p class="noentries">Keine Einträge gefunden.</p>');
        } else {
            this.setupList($parent, 'folders');
            for (let i = 0; i < data.folders.length; i++) {
                let datafolder = new DataFolder(data.folders[i], $parent.find('ul.folders'));
                datafolder.addToList($parent.find('ul.folders'));
            }

            this.setupList($parent, 'files');
            for (let i = 0; i < data.files.length; i++) {
                let datafile = new DataFile(data.files[i], $parent.find('ul.files'));
                datafile.addToList($parent.find('ul.files'));
            }
        }
        $(window).trigger('entriesloaded');
    }

    setupList($parent, $class) {
        $parent.append('<ul class="' + $class + '"></ul>');
    }

    getFolderData(folderId, $parent) {
        $.ajax({
            type: "post",
            dataType: "json",
            url: dataUrl,
            data: {
                "action": dataActionPrefix + "getfolder",
                "folderId": folderId
            },
            beforeSend: () => {
                this.addSpinner();
            },
            complete: () => {
                if (this.deeplinkData == null || this.deeplinkData.length - 1 > this.deeplinkDepth) {
                    this.removeSpinner();
                }
            },
            success: (json) => {
                if (json.success) {
                    this.loadEntries($parent, json.data);
                } else {
                    this.showError("getfolder", json);
                    return false;
                }
            }
        });
    }

    showError(action, json) {
        console.warn(action + " START");
        for (let i = 0; i < json.debug.length; i++) {
            console.warn(json.debug[i]);
        }
        console.warn(action + " END");

        let $html = '<ul>';
        for (let i = 0; i < json.errors.length; i++) {
            $html += '<li>' + json.errors[i] + '</li>';
        }
        $html += '</ul>';

        $.confirm({
            type: 'red',
            typeAnimated: true,
            icon: 'fa fa-warning',
            title: 'Fehler!',
            content: $html,

            buttons: {
                btnClose: {
                    text: 'Schliessen',
                    keys: ['esc']
                }
            }
        });
    }

    addSpinner() {
        this.$spinner.addClass('showing');
    }

    removeSpinner() {
        this.$spinner.removeClass('showing');
    }
}



/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/securearea-next/classes/SecureArea.js
 **/